import { createApi } from 'ReduxHelpers';
import { getBackRoyalApiBaseConfig } from 'BackRoyalApi';
import { type BrowseStream, type BrowseStreamsArgs, type BrowseStreamsResponse } from './BrowseCourses.types';

// snake_case throughout. The casing converter rewrites every key, and the content topic `locales`
// map is keyed by locale code (see StreamEditor/casingRoundTrip.spec.ts). The records also go to
// Iguana unchanged for the access check.
const baseConfig = getBackRoyalApiBaseConfig('browseCoursesApi', { convertCasing: false });

// Mirrors Stream.indexForCurrentUser({ filters: { published: true }, summary: true, include_progress: true })
// and its _optionsForGetCalls. WARNING: the server access rules depend on these filters.
export function buildBrowseStreamsBody({ cohortIds, localeCode }: BrowseStreamsArgs) {
    if (!cohortIds) {
        return {
            filters: { published: true, in_locale_or_en: localeCode, user_can_see: null, in_users_locale_or_en: null },
            summary: true,
            include_progress: false,
        };
    }

    return {
        filters: { published: true, ...(cohortIds.length > 0 ? { cohort_ids: cohortIds } : {}) },
        summary: true,
        include_progress: true,
    };
}

export const browseCoursesApi = createApi('browseCoursesApi', {
    ...baseConfig,
    endpoints: builder => ({
        getBrowseStreams: builder.query<BrowseStream[], BrowseStreamsArgs>({
            query: args => ({
                url: 'lesson_streams/index.json',
                method: 'POST',
                body: buildBrowseStreamsBody(args),
            }),
            transformResponse: (response: BrowseStreamsResponse) => response.contents.lesson_streams,
        }),
    }),
});
